import { render, staticRenderFns } from "./FormFileCategory.vue?vue&type=template&id=5235eda3"
import script from "./FormFileCategory.vue?vue&type=script&lang=js"
export * from "./FormFileCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports